import React, { createContext, useContext, useMemo } from "react";
const identity = (value) => value;
const I18nContext = createContext({ language: "en", t: identity, dictionary: {} });
export function translateText(value, dictionary) {
    if (typeof value !== "string" || !value.trim()) return value;
    const key = value.replace(/\s+/g, " ").trim();
    const translated = dictionary[key];
    if (!translated) return value;
    return (value.match(/^\s+/)?.[0] || "") + translated + (value.match(/\s+$/)?.[0] || "");
}
export function LanguageProvider({ children, language = "en", dictionary = {} }) {
    const value = useMemo(() => ({ language, dictionary, t: language === "hi" ? (text) => translateText(text, dictionary) : identity }), [language, dictionary]);
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
export const useI18n = () => useContext(I18nContext);
